import type { ReactNode, FC } from 'react';
import c from 'classnames';
import s from './SaleLabel.scss';

interface Props {
  className?: string;
  children: ReactNode;
}

const SaleLabel: FC<Props> = ({ className, children }) => {
  return <div className={c(s['root'], className)}>{children}</div>;
};
SaleLabel.displayName = 'SaleLabel';

export default SaleLabel;
